import * as React from "react";
import type { SVGProps } from "react";
const SvgXSign = (props: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    data-name="Layer 2"
    viewBox="0 0 100 100"
    {...props}
  >
    <path
      d="M74.55 100 49.82 65.36 24.91 100H0l37.55-50.75L1.62 0h25.09l23.65 32.77L74.01 0h24.37l-36.1 48.88L100.01 100H74.56Z"
      data-name="Layer 1"
    />
  </svg>
);
export default SvgXSign;
